export const commonConfig = {
  apiKey : 'AIzaSyATSLdFfEua2XNH5WdaIFfMYM55b1s_rhw',
  blogId : '3040540087092322309'
};
